import React, { useState, useEffect } from "react";
import screen1 from "./Cloudimages/app1.jpg";
import screen2 from "./Cloudimages/homeapp.webp";
import screen3 from "./Cloudimages/appsecond.webp";
import screen4 from "./Cloudimages/appthird.webp";
import screen5 from "./Cloudimages/appfour.webp";
import screen6 from "./Cloudimages/appfive.webp";
import screen7 from "./Cloudimages/appsix.webp";
import screen8 from "./Cloudimages/appseven.webp";


import qrImg from "../Cloudkitchen/Cloudimages/image (1).png";

const DownloadApp = () => {
  const [currentScreen, setCurrentScreen] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Screen images with descriptions
  const screenImages = [
    {
      url: screen1,
      title: "Easy Navigation",
      description: "Intuitive interface for seamless user experience"
    },
    {
      url: screen2,
      title: "Real-time Updates",
      description: "Stay updated with live notifications"
    },
    {
      url: screen3,
      title: "Secure & Private",
      description: "Bank-level security for your data"
    },
    {
      url: screen4,
      title: "Custom Dashboard",
      description: "Personalize your workspace"
    },
    {
      url: screen5,
      title: "Custom Dashboard",
      description: "Personalize your workspace"
    },
    {
      url: screen6,
      title: "Custom Dashboard",
      description: "Personalize your workspace"
    },
    {
      url: screen7,
      title: "Custom Dashboard",
      description: "Personalize your workspace"
    },
    {
      url: screen8,
      title: "Custom Dashboard",
      description: "Personalize your workspace"
    }
  ];
  // Auto slide images every 4 seconds
  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        setCurrentScreen((prev) => (prev + 1) % screenImages.length);
      }, 4000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, screenImages.length]);

  // Trigger animation on mount
  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Manual navigation
  const nextScreen = () => {
    setCurrentScreen((prev) => (prev + 1) % screenImages.length);
  };

  const prevScreen = () => {
    setCurrentScreen((prev) => (prev - 1 + screenImages.length) % screenImages.length);
  };

  const goToScreen = (index) => {
    setCurrentScreen(index);
  };

  const toggleAutoPlay = () => {
    setIsAutoPlaying(!isAutoPlaying);
  };

  const handlePlayStoreClick = () => {
  window.open("https://play.google.com/store/apps/details?id=com.maamaas.app", "_blank");
};

const handleAppStoreClick = () => {
  window.open("https://apps.apple.com/us/app/maamaas/id6759244693", "_blank"); // replace with your real App Store link
};


  const handleQRClick = () => {
    alert("Scan QR Code to download the app");
  };

  return (
    <>
      <style>
        {`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: 'Poppins', sans-serif;
        }

        .download-app-section {
          background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
          min-height: 10vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px 20px;
          position: relative;
          overflow: hidden;
          margin-top: 20px;
        
        }

        .download-app-section::before {
          content: '';
          position: absolute;
          width: 600px;
          height: 500px;
          border-radius: 50%;
          background: linear-gradient(135deg, rgba(74, 144, 226, 0.1) 0%, rgba(144, 19, 254, 0.1) 100%);
          top: -300px;
          right: -200px;
          z-index: 0;
        }

        .download-app-section::after {
          content: '';
          position: absolute;
          width: 400px;
          height: 300px;
          border-radius: 50%;
          background: linear-gradient(135deg, rgba(255, 94, 98, 0.1) 0%, rgba(255, 153, 102, 0.1) 100%);
          bottom: -200px;
          left: -150px;
          z-index: 0;
        }

        .download-container {
        
          max-width: 1200px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 60px;
          flex-wrap: wrap;
          z-index: 1;
          position: relative;
        }

        /* ================= LEFT CONTENT ================= */
        .left-content {
          flex: 1;
          min-width: 300px;
          max-width: 500px;
          opacity: ${isVisible ? '1' : '0'};
          transform: ${isVisible ? 'translateX(0)' : 'translateX(-50px)'};
          transition: all 0.8s ease-out;
        }

        .section-tag {
          display: inline-block;
          background: linear-gradient(135deg, #4a90e2, #9013fe);
          color: white;
          padding: 8px 20px;
          border-radius: 30px;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 20px;
          letter-spacing: 1px;
        }

        .main-title {
  font-size: 48px;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 20px;
  color: #ee6521; /* normal text color */
}

.highlight {
  background: linear-gradient(135deg, #ee6521, #ee6521);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

        .description {
          font-size: 18px;
          color: #666;
          line-height: 1.7;
          margin-bottom: 30px;
        }

        .features-list {
          list-style: none;
          margin-bottom: 40px;
        }

        .feature-item {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          font-size: 16px;
          color: #555;
        }

        .feature-icon {
          width: 24px;
          height: 24px;
          background: linear-gradient(135deg, #4a90e2, #9013fe);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 15px;
          color: white;
          font-size: 12px;
        }

        .download-options {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          align-items: center;
        }

        .store-buttons {
          display: flex;
          gap: 15px;
        }

        .store-btn {
          width: 180px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        .store-btn:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
        }

        .playstore-btn {
          background: linear-gradient(135deg, #4285f4, #34a853);
        }

        .appstore-btn {
          background: linear-gradient(135deg, #000000, #333333);
        }

        .store-icon {
          width: 32px;
          height: 32px;
          margin-right: 12px;
        }

        .store-text {
          color: white;
        }

        .store-text span:first-child {
          font-size: 12px;
          display: block;
          margin-bottom: 2px;
        }

        .store-text span:last-child {
          font-size: 18px;
          font-weight: 600;
        }

        .qr-section {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
        }

        .qr-code {
          width: 120px;
          height: 120px;
          border-radius: 12px;
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
          cursor: pointer;
          transition: all 0.3s ease;
          border: 8px solid white;
        }

        .qr-code:hover {
          transform: scale(1.05);
        }

        .qr-text {
          font-size: 14px;
          color: #666;
          font-weight: 500;
        }

        /* ================= RIGHT CONTENT ================= */
        .right-content {
          flex: 1;
          min-width: 300px;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: ${isVisible ? '1' : '0'};
          transform: ${isVisible ? 'translateX(0)' : 'translateX(50px)'};
          transition: all 0.8s ease-out 0.3s;
        }

        .phone-mockup-container {
          position: relative;
          width: 260px;
          height: 540px;
          animation: float 6s ease-in-out infinite;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }

        .phone-frame {
          position: absolute;
          width: 100%;
          height: 100%;
        //   z-index: 20;
          pointer-events: none;
          filter: drop-shadow(0 30px 40px rgba(0, 0, 0, 0.2));
        }

        .phone-screen {
          position: absolute;
          top: 35px;
          left: 22px;
          width: 212px;
          height: 460px;
          border-radius: 32px;
          overflow: hidden;
          background: #000;
          z-index: 10;
        }

        /* SLIDING SCREEN CONTAINER */
        .screen-slider-container {
          width: 100%;
          height: 100%;
          position: relative;
          overflow: hidden;
        }

        .screen-slider-track {
          display: flex;
          height: 100%;
          transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
          transform: translateX(-${currentScreen * 100}%);
        }

        .screen-slide {
          min-width: 100%;
          height: 100%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .screen-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .screen-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        //   background: linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.7) 100%);
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 30px;
          color: white;
          z-index: 15;
        }

        .app-name {
          font-size: 28px;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .app-tagline {
          font-size: 16px;
          opacity: 0.9;
          margin-bottom: 20px;
        }

        /* NAVIGATION CONTROLS */
        .screen-controls {
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          gap: 20px;
          z-index: 25;
        }

        .nav-btn {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 18px;
        }

        .nav-btn:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: scale(1.1);
        }

        .screen-indicators {
          display: flex;
          gap: 8px;
        }

        .indicator {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.5);
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .indicator.active {
          background: white;
          transform: scale(1.2);
        }

        .autoplay-toggle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 14px;
        }

        .autoplay-toggle:hover {
          background: rgba(255, 255, 255, 0.3);
        }

        /* SCREEN COUNTER */
        .screen-counter {
          position: absolute;
          top: 20px;
          right: 20px;
          background: rgba(0, 0, 0, 0.5);
          color: white;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          z-index: 25;
          backdrop-filter: blur(10px);
        }

        /* SCREEN PREVIEW THUMBNAILS */
        .screen-preview {
          position: absolute;
          bottom: -100px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 10px;
          z-index: 30;
        }

        .preview-thumb {
          width: 50px;
          height: 80px;
          border-radius: 8px;
          overflow: hidden;
          cursor: pointer;
          opacity: 0.6;
          transition: all 0.3s ease;
          border: 2px solid transparent;
        }

        .preview-thumb:hover {
          opacity: 0.8;
        }

        .preview-thumb.active {
          opacity: 1;
          border: 2px solid #4a90e2;
          transform: scale(1.1);
        }

        .preview-thumb img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* Responsive Design */
        @media (max-width: 1200px) {
          .download-container {
            gap: 40px;
          }
        }

        @media (max-width: 1024px) {
          .phone-mockup-container {
            width: 340px;
            height: 700px;
          }
          
          .phone-screen {
            top: 45px;
            left: 30px;
            width: 280px;
            height: 610px;
          }
          
          .screen-preview {
            bottom: -90px;
          }
        }

        @media (max-width: 900px) {
          .download-container {
            flex-direction: column;
            // text-align: center;
            gap: 40px;
          }
          
          .left-content, .right-content {
            max-width: 100%;
          }
          
          .feature-item {
            justify-content: center;
          }
          
          .store-buttons {
            justify-content: center;
          }
          
          .download-options {
            justify-content: center;
          }
          
          .phone-mockup-container {
            width: 320px;
            height: 660px;
          }
          
          .phone-screen {
            top: 42px;
            left: 28px;
            width: 264px;
            height: 576px;
          }
          
          .screen-preview {
            bottom: -80px;
          }
          
          .preview-thumb {
            width: 45px;
            height: 70px;
          }
        }

        @media (max-width: 768px) {
          .main-title {
            font-size: 36px;
          }
          
          .description {
            font-size: 16px;
          }
          
          .phone-mockup-container {
            width: 300px;
            height: 620px;
          }
          
          .phone-screen {
            top: 40px;
            left: 26px;
            width: 248px;
            height: 540px;
          }
          
          .app-name {
            font-size: 24px;
          }
          
          .app-tagline {
            font-size: 14px;
          }
          
          .screen-preview {
            bottom: -70px;
          }
          
          .preview-thumb {
            width: 40px;
            height: 65px;
          }
        }

        @media (max-width: 480px) {
          .download-app-section {
            padding: 20px 15px;
          }
          
          .main-title {
            font-size: 28px;
          }
          
          .section-tag {
            font-size: 12px;
            padding: 6px 16px;
          }
          
          .store-btn {
            width: 150px;
            height: 50px;
          }
          
          .store-text span:last-child {
            font-size: 16px;
          }
          
          .phone-mockup-container {
            width: 280px;
            height: 580px;
          }
          
          .phone-screen {
            top: 35px;
            left: 22px;
            width: 236px;
            height: 510px;
            border-radius: 28px;
          }
          
          .nav-btn, .autoplay-toggle {
            width: 35px;
            height: 35px;
            font-size: 14px;
          }
          
          .screen-controls {
            gap: 15px;
          }
          
          .screen-preview {
            bottom: -60px;
          }
          
          .preview-thumb {
            width: 35px;
            height: 55px;
          }
          
          .qr-code {
            width: 100px;
            height: 100px;
          }
        }

        @media (max-width: 380px) {
          .phone-mockup-container {
            width: 260px;
            height: 540px;
          }
          
          .phone-screen {
            top: 32px;
            left: 20px;
            width: 220px;
            height: 476px;
            border-radius: 24px;
          }
          
          .store-buttons {
            flex-direction: column;
            align-items: center;
          }
          
          .store-btn {
            width: 180px;
          }
          
          .screen-preview {
            bottom: -50px;
          }
          
          .preview-thumb {
            width: 30px;
            height: 50px;
          }
        }

        @media (max-width: 320px) {
          .phone-mockup-container {
            width: 240px;
            height: 500px;
          }
          
          .phone-screen {
            top: 30px;
            left: 18px;
            width: 204px;
            height: 440px;
            border-radius: 20px;
          }
          
          .screen-preview {
            display: none;
          }
        }

        /* Animation for slide entrance */
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .screen-slide {
          animation: slideIn 0.5s ease-out;
        }
        `}
      </style>

      <div className="download-app-section">
        <div className="download-container">
          {/* Left Content */}
          <div className="left-content">

            <h1 className="main-title">
  Get Our <span style={{ color: "black" }}>Mobile App</span>
</h1>
            <p className="description">
              Experience a reliable food delivery and restaurant management platform designed for efficiency and convenience. From seamless ordering and real-time tracking to smart restaurant operations, our app helps customers enjoy great food while empowering businesses to manage orders, menus, and deliveries with ease.
            </p>

            {/* <ul className="features-list">
              <li className="feature-item">
                <div className="feature-icon">✓</div>
                <span>Advanced security & privacy protection</span>
              </li>
              <li className="feature-item">
                <div className="feature-icon">✓</div>
                <span>Real-time notifications & updates</span>
              </li>
              <li className="feature-item">
                <div className="feature-icon">✓</div>
                <span>Offline mode availability</span>
              </li>
              <li className="feature-item">
                <div className="feature-icon">✓</div>
                <span>24/7 customer support</span>
              </li>
            </ul> */}

            <div className="download-options">
              <div className="store-buttons">
                <div className="store-btn playstore-btn" onClick={handlePlayStoreClick}>
  <div className="store-icon">
    <svg viewBox="0 0 24 24" fill="white">
      <path d="M3 20.5v-17c0-.58.46-1 1-1h1c.15 0 .28.04.4.11L17.5 12 5.4 20.39c-.12.07-.25.11-.4.11H4c-.54 0-1-.42-1-1zM20.5 12l-4.6-4.23c-.31-.29-.51-.69-.51-1.12 0-.43.2-.83.51-1.12l4.12-3.82c.61-.58 1.6-.04 1.6.84v9.45c0 .88-.99 1.42-1.6.84l-4.12-3.82c-.31-.29-.51-.69-.51-1.12 0-.43.2-.83.51-1.12L20.5 12z" />
    </svg>
  </div>
  <div className="store-text">
    <span>GET IT ON</span>
    <span>Google Play</span>
  </div>
</div>

<div className="store-btn appstore-btn" onClick={handleAppStoreClick}>
  <div className="store-icon">
    <svg viewBox="0 0 24 24" fill="white">
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.31-2.33 1.05-3.11z" />
    </svg>
  </div>
  <div className="store-text">
    <span>Download on the</span>
    <span>App Store</span>
  </div>
</div>
              </div>

              <div className="qr-section">
                <img
                  src={qrImg}
                  alt="QR Code"
                  className="qr-code"
                  onClick={handleQRClick}
                />

                <div className="qr-text">Scan to Download</div>
              </div>
            </div>
          </div>

          {/* Right Content - Phone Mockup with Sliding Screen */}
          <div className="right-content">
            <div className="phone-mockup-container">
              {/* Phone Frame SVG */}
              <svg className="phone-frame" viewBox="0 0 380 780">
                <defs>
                  <linearGradient id="phoneGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#2c3e50" />
                    <stop offset="100%" stopColor="#4a90e2" />
                  </linearGradient>
                  <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
                    <feGaussianBlur in="SourceAlpha" stdDeviation="10" />
                    <feOffset dx="0" dy="10" result="offsetblur" />
                    <feComponentTransfer>
                      <feFuncA type="linear" slope="0.3" />
                    </feComponentTransfer>
                    <feMerge>
                      <feMergeNode />
                      <feMergeNode in="SourceGraphic" />
                    </feMerge>
                  </filter>
                  <linearGradient id="screenGlow" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="rgba(74, 144, 226, 0.1)" />
                    <stop offset="100%" stopColor="rgba(144, 19, 254, 0.1)" />
                  </linearGradient>
                </defs>

                {/* Phone Body */}
                <rect x="20" y="30" width="340" height="720" rx="60" ry="60" fill="url(#phoneGradient)" filter="url(#shadow)" />
                <rect x="24" y="34" width="332" height="712" rx="56" ry="56" fill="#111" />

                {/* Screen Glow Effect */}
                <rect x="34" y="50" width="312" height="676" rx="32" ry="32" fill="url(#screenGlow)" opacity="0.3" />

                {/* Notch */}
                <rect x="140" y="30" width="100" height="20" rx="10" ry="10" fill="url(#phoneGradient)" />

                {/* Side Buttons */}
                <rect x="375" y="180" width="5" height="40" rx="2" ry="2" fill="url(#phoneGradient)" />
                <rect x="375" y="240" width="5" height="60" rx="2" ry="2" fill="url(#phoneGradient)" />
                <rect x="375" y="320" width="5" height="60" rx="2" ry="2" fill="url(#phoneGradient)" />
                <rect x="0" y="180" width="5" height="40" rx="2" ry="2" fill="url(#phoneGradient)" />

                {/* Home Indicator */}
                <rect x="160" y="740" width="60" height="5" rx="2" ry="2" fill="#666" />
              </svg>

              {/* Phone Screen with Sliding Images */}
              <div className="phone-screen">
                <div className="screen-slider-container">
                  <div className="screen-slider-track">
                    {screenImages.map((screen, index) => (
                      <div key={index} className="screen-slide">
                        <img
                          src={screen.url}
                          alt={screen.title}
                          className="screen-image"
                        />
                        {/* <div className="screen-overlay">
                          <div className="app-name">{screen.title}</div>
                          <div className="app-tagline">{screen.description}</div>
                        </div> */}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Screen Counter */}
                {/* <div className="screen-counter">
                  {currentScreen + 1} / {screenImages.length}
                </div> */}

                {/* Navigation Controls */}
                <div className="screen-controls">
                  <button className="nav-btn" onClick={prevScreen} aria-label="Previous screen">
                    ←
                  </button>

                  <div className="screen-indicators">
                    {screenImages.map((_, index) => (
                      <div
                        key={index}
                        className={`indicator ${index === currentScreen ? 'active' : ''}`}
                        onClick={() => goToScreen(index)}
                        aria-label={`Go to screen ${index + 1}`}
                      />
                    ))}
                  </div>

                  <button className="nav-btn" onClick={nextScreen} aria-label="Next screen">
                    →
                  </button>

                  <button
                    className="autoplay-toggle"
                    onClick={toggleAutoPlay}
                    aria-label={isAutoPlaying ? "Pause slideshow" : "Play slideshow"}
                  >
                    {isAutoPlaying ? '⏸' : '▶'}
                  </button>
                </div>
              </div>

              {/* Screen Preview Thumbnails */}
              {/* <div className="screen-preview">
                {screenImages.map((screen, index) => (
                  <div
                    key={index}
                    className={`preview-thumb ${index === currentScreen ? 'active' : ''}`}
                    onClick={() => goToScreen(index)}
                  >
                    <img src={screen.url} alt={`Preview ${index + 1}`} />
                  </div>
                ))}
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DownloadApp;